import React, { useContext, useEffect, useState } from 'react'
import { Grid } from "@mui/material";
import { styled } from "@mui/material/styles";
import CloudUploadIcon from "@mui/icons-material/CloudUpload";
import Button from "@mui/material/Button";
import Stack from "@mui/material/Stack";
import { DataGrid, GridCellEditStopReasons } from '@mui/x-data-grid';
import UiSwitch from '../../../_uiMocks/_uiComponents/UiSwitch';
import { UiButton, UiButtonDataManagement } from '../../../_uiComponents/common/form/UiButton';
import ImportedRecords from './ImportedRecords';
import { contextApiActions, lookupTableConstants } from "../../../../_redux/_constants";
import { Context } from "../../../../_context/Store";
import Papa from 'papaparse';
import { useDispatch } from 'react-redux';
import { ajaxError, factTableCSVFileUploadRequest, lookupTableCSVFileUploadRequest, lookupTableListRequest } from '../../../../_redux/_actions';
import { useSelector } from 'react-redux';
import UiCheckbox from '../../../_uiComponents/common/form/UiCheckBox';
import { PageLoader } from '../../../_uiComponents/common/UiLoadingSpinner';
import DeleteIcon from '@mui/icons-material/Delete';
import IconButton from "@mui/material/IconButton";

export default function CreateByFileImport(props, { rowTableData }) {

    const [state, dispatch] = useContext(Context);
    const [tableRows, setTableRows] = useState([]);
    const [firstRowtableRows, setFirstRowTableRows] = useState([]);
    const [firstRowCheck, setFirstRowCheck] = useState(true);
    const [csvFormatedData, setCsvFormatedData] = useState([]);
    const [loadingFileUploader, setLoadingFileUploader] = useState(false);
    const [selectedRows, setSelectedRows] = React.useState([]);
    const [selectedTable, setSelectedTable] = useState([]);
    let tableDataList = [];
    let tableNewList = [];
    const actionDispatch = useDispatch();

    const { lookupTable } = useSelector((state) => {
        return {
            lookupTable: state.lookupTable,
        };
    });

    const VisuallyHiddenInput = styled("input")({
        clip: "rect(0 0 0 0)",
        clipPath: "inset(50%)",
        height: 1,
        overflow: "hidden",
        position: "absolute",
        bottom: 0,
        left: 0,
        whiteSpace: "nowrap",
        width: 1,
    });

    const columns = [
        {
            field: 'table_name',
            headerName: 'Table Name',
            width: 230,
            type: 'text',
            editable: true,
            align: 'left',
            sortable: false,
            filterable: false,
            disableColumnMenu: true,
            hideable: false,
            resizable: false,

        },
        {
            field: 'formatted_table_name',
            headerName: 'Formatted Table Name',
            align: 'center',
            headerAlign: 'center',
            width: 230,
            sortable: false,
            filterable: false,
            disableColumnMenu: true,
            hideable: false,
            resizable: false,
        },
        {
            field: 'total_records',
            headerName: 'Total Records',
            align: 'center',
            headerAlign: 'center',
            width: 150,
            sortable: false,
            filterable: false,
            disableColumnMenu: true,
            hideable: false,
            resizable: false,
        },

        {
            field: 'import_records',
            headerName: 'Import Records',
            align: 'center',
            headerAlign: 'center',
            width: 150,
            sortable: false,
            filterable: false,
            disableColumnMenu: true,
            hideable: false,
            resizable: false,
            renderCell: (params) => (
                <UiSwitch
                    onClick={(event) => { handleChangeSwitch(event, params) }}
                    checked={params?.row?.switchValue}
                />
            ),
        },
        {
            field: 'delete',
            headerName: '',
            align: 'center',
            headerAlign: 'center',
            width: 80,
            sortable: false,
            filterable: false,
            disableColumnMenu: true,
            hideable: false,
            resizable: false,
            renderCell: (params) => (
                <IconButton onClick={(event) => { handleDelete(event, params) }}>
                    <DeleteIcon className="sb-table-row-delete"  />
                </IconButton>
                

            ),
        },
    ]



    const processRowUpdate = (newRow) => {
        const rowIndexToUpdate = tableRows.findIndex((row) => row.id === newRow.id);

        if (rowIndexToUpdate !== -1) {
            const newData = [...tableRows];
            newData.splice(rowIndexToUpdate, 1, newRow);

            const rows = newData.map((column, index) => ({
                id: index + 1,
                table_name: column?.table_name,
                name: column?.table_name.replace(/ /g, "_"),
                formatted_table_name: column?.table_name.replace(/ /g, "_"),
                total_records: column?.total_records,
                values: column?.values,
                active: true,
                switchValue: column?.switchValue,
                labels: [],
            }));
            setTableRows(rows)
        }
    };



    useEffect(() => {
        if (lookupTable?.status) {
            dispatch({
                type: contextApiActions.UI_LARGE_MODAL_TOGGEL,
                payload: {
                    show: true,
                    children: <ImportedRecords />,
                },
            });
            actionDispatch(
                lookupTableListRequest({
                    page: 1,
                    pageSize: 5,
                }),
            );

        }
    }, [lookupTable?.status]);

    const handleFileImport = () => {
        const selectedDataValues = tableRows.filter(obj => obj.switchValue);

        const rows = selectedDataValues.map((column, index) => ({
            id: column?.id,
            name: column?.name,
            labels: [],
            values: column?.switchValue ? column?.values : [],
            active: true,
        }))

        if (rows.length !== 0) {
            actionDispatch(lookupTableCSVFileUploadRequest({ payload: rows }));
        } else {
            actionDispatch(
                ajaxError({
                     message: "ajax error 400",
                     name: "AjaxError",
                     response: {
                        statusCode: "0104062024",
                        message: [
                             "Please select Type of each selected row",
                        ],
                        error: "Service error",
                   },

                     status: 400,
                }),
           );
        }
    };

    const handleChangeSwitch = (event, params) => {
        event.stopPropagation();

        const selectedRowId = params.row.id;

        if (event.target.checked) {
            const updatedRows = tableRows.map(row => ({
                ...row,
                switchValue: row.id === selectedRowId ? true : row.switchValue
            }));
            setTableRows(updatedRows);
        } else {
            const updatedRows = tableRows.map(row => ({
                ...row,
                switchValue: row.id !== selectedRowId ? row.switchValue : false
            }));
            setTableRows(updatedRows);
        }
    };

    const calculateTotalRecodes = (rowDate, column) => {
        return rowDate.filter(row => row[column] !== null && row[column] !== undefined).length;
    }

    const extractValues = (rowDate, column) => {
        return rowDate.map(row => row[column]).filter(value => value !== null && value !== undefined);

    }

    const csvFileUploader = (data) => {
        setLoadingFileUploader(true);
        const file = data?.target?.files[0];
        if (file?.type === lookupTableConstants.CSV_FILE_TYPE) {
            Papa.parse(file, {
                header: true,
                dynamicTyping: true,
                complete: function (results) {
                    setLoadingFileUploader(false);
                    const columns = results.meta.fields;
                    const rowsData = results.data;

                    const rows = columns.map((column, index) => ({
                        id: index + 1,
                        table_name: column,
                        name: column.replace(/ /g, "_"),
                        formatted_table_name: column.replace(/ /g, "_"),
                        total_records: calculateTotalRecodes(rowsData, column),
                        values: extractValues(rowsData, column),
                        active: true,
                        labels: [],
                        switchValue: true,
                    }));
                    setCsvFormatedData(rows);
                    setTableRows(rows)
                },
                error: function (error) {
                    actionDispatch(
                        ajaxError({
                            message: "ajax error 400",
                            name: "AjaxError",
                            response: {
                                statusCode: "0107052024",
                                message: ["CSV parsing error"],
                                error: "Service error",
                            },

                            status: 400,
                        }),
                    )
                }
            })
        }
    }

    function CustomNoRowsOverlay() {
        return (
            <div className="sba-no-data-row">
                No Data
            </div>
        )
    }

    const firstRowChecked = (event) => {
        if (event.target.checked) {
            setFirstRowCheck(true)
            setTableRows(csvFormatedData)
        } else {
            const rows = tableRows.map((column, index) => ({
                id: index + 1,
                table_name: `Lookup_Table_${index + 1}`,
                name: `Lookup_Table_${index + 1}`,
                formatted_table_name: `Lookup_Table_${index + 1}`,
                total_records: column?.total_records,
                values: column?.values,
                switchValue: column?.switchValue,
                active: true,
                labels: [],
            }));
            setTableRows(rows)
            setFirstRowCheck(false)
        }
    }

    const handleDelete = (event, params) => {
        dispatch({
             type: contextApiActions.UI_CONFIRMATION_TOGGEL,
             payload: {
                  show: true,
                  okFunction: () => {
                       let newValues = tableRows.filter(function (obj) {
                            return obj.id !== params.row.id;
                       });

                       setTableRows(newValues);
                  },
             },
        });
   };

    const addNewRow = () => {
        const newRow = {
            id:tableRows.length + 1,
            table_name: `Lookup_Table_${tableRows.length + 1}`,
            name: `Lookup_Table_${tableRows.length + 1}`,
            formatted_table_name: `Lookup_Table_${tableRows.length + 1}`,
            total_records: 0,
            values: 0,
            active: true,
            labels: [],
        }
        setTableRows([...tableRows, newRow]);
    }

    return (
        <>
            <Grid container spacing={2} sx={{ mt: 1 }}>
                <PageLoader show={loadingFileUploader} />
                <Grid item xs={12} lg={12} className='sba-create-by-file-import-top-heading'>
                    <Button
                        component="label"
                        role={undefined}
                        variant="contained"
                        tabIndex={-1}

                        startIcon={<CloudUploadIcon />}
                    >
                        Upload file
                        <VisuallyHiddenInput
                            type="file"
                            accept=".csv"
                            onChange={(e) => csvFileUploader(e)}

                        />
                    </Button>

                    <p className='sba-csv-upload-comment'>
                        Only CSV (Comma separated values) files are allowed and the file size should not exceed 5MB. </p>
                </Grid>
                {tableRows?.length !== 0 &&
                    <>
                        <div className='sba-table-head-inst-wr'>
                            <div className='sba-table-head-instructions'>
                                <UiCheckbox handleChange={(e) => { firstRowChecked(e) }} checked={firstRowCheck} label="First row is header" />
                                <span>To import the values, please select the required column.
                                </span>
                            </div>
                            <div className='sb-add-row-btn'>
                                <UiButtonDataManagement name="Add Lookup Table Row" variant="contained" onClick={addNewRow} />
                            </div>
                        </div>
                        <Grid item xs={12} lg={12} className='sba-auto-datagrid-tbl'>
                            <DataGrid
                                rows={tableRows}
                                columns={columns}
                                processRowUpdate={processRowUpdate}
                                slots={{
                                    noRowsOverlay: CustomNoRowsOverlay,
                                }}
                                hideFooterPagination
                                hideFooter

                            />
                        </Grid>
                    </>
                }
                <Grid item xs={12} lg={12}>
                    <Stack spacing={2} direction="row" justifyContent="end" sx={{ width: '100%', mt: 3 }}>
                        <UiButton name="Import" variant="contained" size="small" onClick={handleFileImport} />
                    </Stack>
                </Grid>
            </Grid>

        </>
    )
}
